import { cn as e } from "../utils/index.js";
import "react";
import { jsx as t } from "react/jsx-runtime";
import { cva as n } from "class-variance-authority";
import { Slot as r } from "@radix-ui/react-slot";
//#region src/components/badge.tsx
var i = n("inline-flex items-center justify-center rounded-full border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden", {
	variants: { variant: {
		default: "border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90",
		secondary: "border-transparent bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90",
		destructive: "border-transparent bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
		outline: "text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground"
	} },
	defaultVariants: { variant: "default" }
});
function a({ className: n, variant: a, asChild: o = !1, ...s }) {
	return /* @__PURE__ */ t(o ? r : "span", {
		"data-slot": "badge",
		className: e(i({ variant: a }), n),
		...s
	});
}
//#endregion
export { a as Badge, i as badgeVariants };
